import React, { useEffect, useState, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loader from "../../Components/Core/Loader";
import { AddConsultion } from "../../Services/ConsultionService";

const ConsultationCallback = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const verifyPayment = useCallback(async () => {
    const authority =
      searchParams.get("Authority") ||
      searchParams.get("authority") ||
      searchParams.get("RefNum") ||
      searchParams.get("refNum");
    const rawStatus =
      searchParams.get("Status") ||
      searchParams.get("status") ||
      searchParams.get("State") ||
      searchParams.get("state") ||
      "";
    const status = rawStatus.toUpperCase();

    if (status === "NOK" || status === "CANCELED" || !authority) {
      localStorage.removeItem("consultationGateway");
      navigate("/counseling/fail", { replace: true });
      return;
    }

    try {
      setLoading(true);

      const gateway = localStorage.getItem("consultationGateway") || "zarinpal";
      const verificationResponse = await AddConsultion(authority, gateway);
      localStorage.removeItem("consultationGateway");

      if (verificationResponse?.id) {
        navigate(`/counseling/chat/${verificationResponse.id}`, { replace: true });
      } else {
        navigate("/counseling/fail", { replace: true });
      }
    } catch (error) {
      localStorage.removeItem("consultationGateway");
      console.error("Payment verification failed:", error);
      navigate("/counseling/fail", { replace: true });
    } finally {
      setLoading(false);
    }
  }, [navigate, searchParams]);

  useEffect(() => {
    verifyPayment();
  }, [searchParams, verifyPayment]);

  return loading ? <Loader /> : null;
};

export default ConsultationCallback;
